<!-- ::START::LICENCE::
Copyright eQualityTime ©2018, ©2019, ©2020, ©2021, ©2022, ©2023, ©2024, ©2025
This file is part of OVFPlayer.
OVFPlayer is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.
OVFPlayer is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU General Public License for more details.
You should have received a copy of the GNU General Public License
along with OVFPlayer.  If not, see <https://www.gnu.org/licenses/>.
::END::LICENCE:: -->
@if (board) {
  <div class="board">
    @for (row of buttonProvider.getScannableCollections(); track $index) {
      <div class="boardRow"
        [class.scanHighlight]="row.isHighlighted()"
        [class.scanSelect]="row.isSelection()"
        [style.height]="row.rowHeight">
        @for (butt of row.displayButtons; track $index) {
          <div class="boardButton"
            [class.scanHighlight]="butt && butt.isHighlighted()"
            [class.scanSelect]="butt && butt.isSelection()">
            @if (butt) {
              <app-obf-button [butt]="butt.button" [clickHandler]="handleButtonClick.bind(this)"></app-obf-button>
            }
          </div>
        }
      </div>
    }
  </div>
} @else {
  <app-progress></app-progress>
}

